<!-- @Version: 1.0.3 -->
@if (done$$() == true) {
  <form [formGroup]="fgToggle" data-testid="togglecontainer" class="column">
    <div class="toggle-container">
      <mat-button-toggle-group [formControlName]="FC_TOGGLE.TOGGLEBUTTON" [class.mat-toggle-group-checked]="this.fgToggle.dirty" >
        @for (button of sFieldItemToggle.toggleButtons; track button; let idx = $index) {
          <mat-button-toggle [attr.color]="TRANSLATE_PATH_SHARED.COLOR_TOGGLE | translateDesign" data-testid="mat-toggle-button" [value]="button.value">
            {{button.label}}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
    <div class="error-messages">
      @if (fgToggle.errors?.required && !fgToggle.errors?.valid && fgToggle.dirty) {
        <mat-error data-testid="error-required">{{sFieldItemToggle.errorCodes.errorCodeRequired}}</mat-error>
      }
      @if (fgToggle.errors?.valid) {
        <mat-error data-testid="error-valid">{{sFieldItemToggle.errorCodes.errorCodeValid}}</mat-error>
      }
      @if ((fieldItem.required && fgToggle.pristine) || (fieldItem.required && fgToggle.dirty && fgToggle.valid)) {
        <mat-hint data-testid="hint-required">{{TRANSLATE_PATH_SHARED.REQUIRED | translateDesign}}</mat-hint>
      }
      @if (!(fgToggle.errors?.required && !fgToggle.errors?.valid && fgToggle.dirty) && !(fgToggle.errors?.valid) && !(fieldItem.required && !fgToggle.get(FC_TOGGLE.TOGGLEBUTTON)?.disabled && !(fgToggle.errors?.required && !fgToggle.errors?.valid && fgToggle.dirty))) {
        <mat-hint data-testid="hint-placeholder"> </mat-hint>
      }
    </div>
  </form>
}